import { Component, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { Status } from '../../../shared/enums/status';

@Component({
  selector: 'hub-status',
  standalone: true,
  imports: [TooltipModule],
  template: `
    @switch (status) {
      @case (statusEnum.Pendente) {
        <span pTooltip="Pendente" tooltipPosition="left">
          <i class="pi pi-circle-fill tw-text-yellow-500"></i>
        </span>
      }
      @case (statusEnum.Processamento) {
        <span pTooltip="Processando" tooltipPosition="left">
          <i class="pi pi-circle-fill tw-text-blue-500"></i>
        </span>
      }
      @case (statusEnum.Finalizado) {
        <span pTooltip="Finalizado" tooltipPosition="left">
          <i class="pi pi-circle-fill tw-text-green-500"></i>
        </span>
      }
      @default {
        <span pTooltip="Finalizado com erro" tooltipPosition="left">
          <i class="pi pi-circle-fill tw-text-red-500"></i>
        </span>
      }
    }
  `,
  styleUrl: './status.component.scss',
})
export class StatusComponent {
  @Input({ required: true }) status!: number;
  public statusEnum = Status;
}
